import React from 'react'
import { useDispatch } from 'react-redux'

import FomrDadosEmpresarial from './components/FormDadosEmpresarial'

function DadosEmpresarial() {
    const dispatch = useDispatch()


    return (
        <div>
            <FomrDadosEmpresarial />
        </div>
    )
}

export default DadosEmpresarial;